/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { chatCountModelSchema } from "../chatCountModelSchema.ts";
import { getMessagesCountQuerySchema } from "../getMessagesCountQuerySchema.ts";
import { z } from "zod";

export const getApiFeedbacksCountQueryParamsSchema = z.object({
    "query": z.lazy(() => getMessagesCountQuerySchema).describe("Модель запроса").optional()
    }).optional()

/**
 * @description Число сообщений
 */
export const getApiFeedbacksCount200Schema = z.lazy(() => chatCountModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiFeedbacksCount400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiFeedbacksCount401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiFeedbacksCount403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Not Found
 */
export const getApiFeedbacksCount404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiFeedbacksCount500Schema = z.lazy(() => badResponseModelSchema)

export const getApiFeedbacksCountQueryResponseSchema = z.lazy(() => getApiFeedbacksCount200Schema)